<script setup lang="ts">
import { ArrowRight, Bot, Users } from "lucide-vue-next";
import { ref } from "vue";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { usePlay } from "@/composables/usePlay";
import { useGameStore } from "@/stores/game";
import { useLobbyStore } from "@/stores/lobby";

const lobby = useLobbyStore();
const game = useGameStore();
const open = ref(false);
const { busy, start: startPlay } = usePlay();
async function start(bots: boolean) {
	if (await startPlay(bots ? "bots" : "table")) open.value = false;
}
</script>
<template>
    <div class="play-dock">
        <RouterLink v-if="game.myUuid || lobby.lobbyID > 0" to="/" class="dock-button">{{ game.myUuid ? 'Return to game' : 'Return to table' }}<ArrowRight class="size-5" /></RouterLink>
        <button v-else class="dock-button" @click="open = true">Play<ArrowRight class="size-5" /></button>
    </div>
    <Sheet :open="open" @update:open="open = $event">
        <SheetContent side="bottom" class="rounded-t-2xl">
            <div class="mx-auto max-w-lg">
                <SheetHeader><SheetTitle>Play</SheetTitle><SheetDescription>Start with bots or assemble your table.</SheetDescription></SheetHeader>
                <div class="grid gap-3 mt-5">
                    <button class="choice" :disabled="!!busy" @click="start(true)"><Bot class="size-6" /><span>{{ busy ? 'Setting up your table…' : 'Play with bots' }}</span></button>
                    <button class="choice" :disabled="!!busy" @click="start(false)"><Users class="size-6" /><span>Create a table</span></button>
                </div>
            </div>
        </SheetContent>
    </Sheet>
</template>
<style scoped>
.play-dock { position: fixed; bottom: calc(12px + env(safe-area-inset-bottom)); left: max(16px, env(safe-area-inset-left)); right: max(16px, env(safe-area-inset-right)); z-index: 30; pointer-events: none; }
.dock-button { pointer-events: auto; display: flex; align-items: center; justify-content: center; gap: 16px; width: 100%; max-width: 520px; margin: auto; padding: 16px 24px; border-radius: 12px; background: hsl(var(--primary)); color: hsl(var(--primary-foreground)); font-size: 19px; font-weight: 700; }
.choice { display: flex; align-items: center; gap: 16px; padding: 18px; border: 1px solid hsl(var(--border)); border-radius: 12px; text-align: left; font-weight: 600; }
.choice:hover { background: hsl(var(--muted)); }
.choice:disabled { opacity: .5; cursor: wait; }
.dock-button { padding: 12px 20px; font-size: 16px; border-radius: 10px; }
button:focus-visible, a:focus-visible { outline: 2px solid hsl(var(--primary)); outline-offset: 4px; }
@media (min-width: 1024px) { .play-dock { bottom: 24px; left: 260px; } }
</style>
